import { useRef, useState, useCallback } from 'react';
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";

const usePdfExport = (options = {}) => {
  const [isExporting, setIsExporting] = useState(false);
  const componentRef = useRef(null);

  const exportToPDF = useCallback(async () => {
    console.log("HERE", componentRef.current)
    if (!componentRef.current) return;

    setIsExporting(true);
    console.log("HERE")

    const {
      filename = 'export.pdf',
      scale = 2,
      onBeforeExport,
      onAfterExport,
      pdfOptions = {},
    } = options;

    try {
      if (onBeforeExport) await onBeforeExport();

      const element = componentRef.current;
      const canvas = await html2canvas(element, { scale,
        useCORS: true, // This might help with cross-origin images
        logging: true, // This will log helpful information to console
      });
      const imgData = canvas.toDataURL('image/png');

      const pdf = new jsPDF({
        orientation: 'p',
        unit: 'in',
        format: [8.5, 16],  // width, height
        compress: true,
      });

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      // Use the full width of the page
      const imgWidth = pdfWidth;
      // Calculate height while maintaining aspect ratio
      const imgHeight = (canvas.height / canvas.width) * imgWidth;

      // Start from the top of the page
      const imgY = 0;

      pdf.addImage(imgData, 'PNG', 0, imgY, imgWidth, imgHeight);
      pdf.save(filename);

      if (onAfterExport) await onAfterExport();
    } catch (error) {
      console.error('PDF export failed:', error);
    } finally {
      setIsExporting(false);
    }
  }, [options]);

  return { exportToPDF, componentRef, isExporting };
};

export default usePdfExport;